import {AUTHORIZATION,COMPANIES} from './../constants/constants'

export function setAuth (token) {
  localStorage.setItem(AUTHORIZATION, token)
}

export function setCompanies (companies) {
  localStorage.setItem(COMPANIES, companies)
}

export function resetAuth () {
  localStorage.removeItem(AUTHORIZATION)
  localStorage.removeItem(COMPANIES)
}
